import React, { useEffect, useState, useRef, useMemo } from 'react';
import api from '../services/api';
import logo from '../assets/FCI Logo - Cropped.png';
import '../css/requisition-app-styles.css';
import { Link } from 'react-router-dom';
import userIcon from '../img/User-Icon.png';
import TopBarIcons from './TopBarIcons';
import axios from 'axios';
import { useLocation, useNavigate } from "react-router-dom";
import "../css/Requisitions.css";
import Sidebar from './Sidebar';
import { jwtDecode } from 'jwt-decode';
import PrintButton from './PrintButton';
import ExportPDFButton from './ExportPDFButton';
import ExportExcelButton from './ExportExcelButton';

const ApprovedRequisitionsReviewerView = () => {
  const navigate = useNavigate();
  const location = useLocation(); 
  const [requisitions, setRequisitions] = useState([]);
  const [disbursedRequisitions, setDisbursedRequisitions] = useState([]);
  const theUserType = localStorage.getItem('userType');
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState(location.state?.defaultTab || 'Approved'); 
  const storedFullName = localStorage.getItem('fullName');
  const [reviewers, setReviewers] = useState([]);
  const theUserId = localStorage.getItem('userId');
  const [reviewerNumber, setReviewerNumber] = useState(null);
  const [formArray, setFormArray] = useState([]);
  const contentRef = useRef();
  const [loadingApproved, setLoadingApproved] = useState(false);
  const [loadingDisbursed, setLoadingDisbursed] = useState(false);

  // Search and pagination state
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(20);

  const [formData, setFormData] = useState(() => {
    return {
      country: '',
      staffName: '',
      staffLevel: '',
      projectCode: '',
      activityPurpose: '',
      projectName: '',
      from: '',
      to: '',
      activityName: '',
      hubOffice: '',
      supervisorName: '',
      budgetLineCode: '',
      targetClient: '',
      expectedImpact: '',
      userType: '',
      userId: '',
      payMode: '',
      bankName:'',
      branch:'',
      accountNumber: '',
      phoneNumber: '',
      requisitionDate: '', 
      requisitionID: '',
      status: 'Draft',  
      costDrivers: [{ costDriver: '', customCostDriver: '' }], 
      districtAndAreaProgramPairs: [
        { district: "", areaProgram: "" }
      ], 
    };
  });

  useEffect(() => {
    const fetchReviewers = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/users/reviewers`);
        const data = response.data;

        if (!Array.isArray(data.$values)) {
          console.error("Unexpected response format:", data);
          setReviewers([]);
          return;
        }

        const allReviewers = data.$values.map(r => ({
          ...r,
          id: String(r.id)
        }));
        setReviewers(allReviewers);

        if (!theUserId) return;

        const current = allReviewers.find(r => r.id === String(theUserId));
        if (!current) return;

        const currentNum = current.reviewerNumber;
        setReviewerNumber(currentNum);

      } catch (error) {
        console.error("Error fetching reviewers:", error);
        setReviewers([]);
      }
    };

    fetchReviewers();
  }, [theUserId]);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) return;

    const decoded = jwtDecode(token); 
    setReviewerNumber(decoded.reviewerNumber || null); 
    console.log("Reviewer number", reviewerNumber);
  }, []);

  useEffect(() => {
    if (activeTab === 'Approved') {
      fetchApprovedRequisitions();
    } else if (activeTab === 'Disbursed') {
      fetchDisbursedRequisitions();
    }
  }, [activeTab]);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    setCurrentPage(1);
    setSearchTerm(''); // Clear search when changing tabs
  };

  const handleView = (requisitionID) => {
    navigate(`/review-requisition/${requisitionID}`);
  };

  // Fetch requisitions with status "Approved"
  const fetchApprovedRequisitions = async () => {
    try {
      setLoadingApproved(true);
      console.log("Fetching approved requisitions...");
      const token = localStorage.getItem("token");
      const userId = localStorage.getItem("userId"); 

      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/Requisition/status`, {
        params: {
          status: 'Approved',
          excludeUserId: userId,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = Array.isArray(response.data)
        ? response.data
        : response.data.$values ?? [];

      console.log("Basic approved requisitions fetched:", data);

      // Fetch detailed data for each requisition to get cost drivers
      const detailedRequisitions = await Promise.all(
        data.map(async (requisition) => {
          try {
            const detailResponse = await axios.get(
              `${process.env.REACT_APP_API_BASE_URL}/Requisition/${requisition.requisitionID}`,
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            );

            console.log(`Full API response for ${requisition.requisitionID}:`, detailResponse.data); 
            return detailResponse.data;
          } catch (error) {
            console.error(`Error fetching details for ${requisition.requisitionID}:`, error);
            return requisition; // Return original if detail fetch fails
          }
        })
      );

      console.log("Detailed approved requisitions with cost drivers:", detailedRequisitions);
      setRequisitions(detailedRequisitions);
      setError(null);
    } catch (err) {
      console.error("Error fetching approved requisitions:", err);
      if (err.response?.status === 404) {
        setError(`No approved requisitions found.`);
      } else if (err.response?.status === 401) {
        setError("You must be logged in to view requisitions.");
      } else {
        setError("Error fetching approved requisitions.");
      }
      setRequisitions([]);
    } finally {
      setLoadingApproved(false);
    }
  };

  // Fetch requisitions with status "Disbursed"
  const fetchDisbursedRequisitions = async () => {
    try {
      setLoadingDisbursed(true);
      console.log("Fetching disbursed requisitions...");
      const token = localStorage.getItem("token");
      const userId = localStorage.getItem("userId"); 

      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/Requisition/status`, {
        params: {
          status: 'Disbursed',
          excludeUserId: userId,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = Array.isArray(response.data)
        ? response.data
        : response.data.$values ?? [];

      console.log("Basic disbursed requisitions fetched:", data);

      // Fetch detailed data for each requisition to get cost drivers
      const detailedRequisitions = await Promise.all(
        data.map(async (requisition) => {
          try {
            const detailResponse = await axios.get(
              `${process.env.REACT_APP_API_BASE_URL}/Requisition/${requisition.requisitionID}`,
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            );

            console.log(`Full API response for ${requisition.requisitionID}:`, detailResponse.data); 
            return detailResponse.data;
          } catch (error) {
            console.error(`Error fetching details for ${requisition.requisitionID}:`, error);
            return requisition; // Return original if detail fetch fails
          }
        })
      );

      console.log("Detailed disbursed requisitions with cost drivers:", detailedRequisitions);
      setDisbursedRequisitions(detailedRequisitions);
      setError(null);
    } catch (err) {
      console.error("Error fetching disbursed requisitions:", err);
      if (err.response?.status === 404) {
        setError(`No disbursed requisitions found.`);
      } else if (err.response?.status === 401) {
        setError("You must be logged in to view requisitions.");
      } else {
        setError("Error fetching disbursed requisitions.");
      }
      setDisbursedRequisitions([]);
    } finally {
      setLoadingDisbursed(false);
    }
  };

  // Format date
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return `${date.getDate()} ${date.toLocaleString("en-US", { month: "long" })} ${date.getFullYear()}`;
  };

  // Format date range
  const formatDateRange = (fromDate, toDate) => {
    if (!fromDate || !toDate) return 'N/A';
    const from = new Date(fromDate);
    const to = new Date(toDate);
    return `${from.getDate()} ${from.toLocaleString("en-US", { month: "short" })} - ${to.getDate()} ${to.toLocaleString("en-US", { month: "short" })} ${to.getFullYear()}`;
  };

const calculateTotalAmount = (requisition) => {
  let total = 0;
  
  // Add Other Cost Drivers total
  if (requisition.costDrivers && requisition.costDrivers.length > 0) {
    const costDrivers = Array.isArray(requisition.costDrivers) 
      ? requisition.costDrivers 
      : requisition.costDrivers.$values || [];
      
    total += costDrivers.reduce((sum, driver) => {
      const driverTotal = driver.totalTotal || driver.total || 0;
      return sum + (parseFloat(driverTotal) || 0);
    }, 0);
  }
  
    // Add Blasting Cost Drivers total
    if (requisition.blastingCostDrivers && requisition.blastingCostDrivers.length > 0) {
      const blastingDrivers = Array.isArray(requisition.blastingCostDrivers) 
        ? requisition.blastingCostDrivers 
        : requisition.blastingCostDrivers.$values || [];
        
      total += blastingDrivers.reduce((sum, driver) => {
        const driverTotal = driver.totalTotal || driver.total || 0;
        return sum + (parseFloat(driverTotal) || 0);
      }, 0);
    }
    
    return total;
  };

  const getStatusClass = (status) => {
    if (status === "Approved") return "status-approved";
    if (status === "Disbursed") return "status-disbursed";
    if (status.startsWith("Reviewed by")) return "status-reviewed";
    return "";
  };

  const getExportData = () => {
    if (activeTab === 'Approved') {
      return requisitions.map(requisition => ({
        'Staff Name': requisition.staffName,
        'Activity Name': requisition.activityName,
        'Activity Duration': formatDateRange(requisition.from, requisition.to),
        'Cost Drivers Total': calculateTotalAmount(requisition),
        'Approved Date': formatDate(requisition.approvedDate || requisition.requisitionDate),
        'Status': requisition.status,
        'Requisition ID': requisition.requisitionID
      }));
    } else if (activeTab === 'Disbursed') {
      return disbursedRequisitions.map(requisition => ({
        'Staff Name': requisition.staffName,
        'Activity Name': requisition.activityName,
        'Activity Duration': formatDateRange(requisition.from, requisition.to),
        'Amount Disbursed': calculateTotalAmount(requisition),
        'Disbursed Date': formatDate(requisition.disbursedDate),
        'Status': requisition.status,
        'Requisition ID': requisition.requisitionID
      }));
    }
    return [];
  };

  const calculateTotalApprovedAmount = () => {
    return requisitions.reduce((total, requisition) => {
      return total + calculateTotalAmount(requisition);
    }, 0);
  };

  const calculateTotalDisbursedAmount = () => {
    return disbursedRequisitions.reduce((total, requisition) => {
      return total + calculateTotalAmount(requisition);
    }, 0);
  };

  // Handle search change
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1); // Reset to first page when searching
  };

  // Filter requisitions based on search term
  const filterRequisitions = (requisitionsList) => {
    if (!searchTerm.trim()) return requisitionsList;
    
    const searchLower = searchTerm.toLowerCase();
    return requisitionsList.filter(requisition => {
      // Search in Staff Name
      if (requisition.staffName && requisition.staffName.toLowerCase().includes(searchLower)) {
        return true;
      }
      // Search in Activity Name
      if (requisition.activityName && requisition.activityName.toLowerCase().includes(searchLower)) {
        return true;
      }
      // Search in Activity Purpose
      if (requisition.activityPurpose && requisition.activityPurpose.toLowerCase().includes(searchLower)) {
        return true;
      }
      // Search in Activity Duration
      if (requisition.from) {
        const fromDate = new Date(requisition.from);
        const formattedFrom = `${fromDate.getDate()} ${fromDate.toLocaleString("en-US", { month: "long" })} ${fromDate.getFullYear()}`;
        if (formattedFrom.toLowerCase().includes(searchLower)) {
          return true;
        }
      }
      // Search in Status
      if (requisition.status && requisition.status.toLowerCase().includes(searchLower)) {
        return true;
      }
      // Search in Requisition ID
      if (requisition.requisitionID && requisition.requisitionID.toLowerCase().includes(searchLower)) {
        return true;
      }
      // Search in District and AP
      let districtPairs = [];
      if (requisition.districtAndAreaProgramPairs?.$values?.length > 0) {
        districtPairs = requisition.districtAndAreaProgramPairs.$values;
      } else if (Array.isArray(requisition.districtAndAreaProgramPairs) && requisition.districtAndAreaProgramPairs.length > 0) {
        districtPairs = requisition.districtAndAreaProgramPairs;
      }
      const hasDistrictMatch = districtPairs.some(pair => {
        const district = (pair.district || '').toLowerCase();
        const areaProgram = (pair.areaProgram || '').toLowerCase();
        return district.includes(searchLower) || areaProgram.includes(searchLower);
      });
      return hasDistrictMatch;
    });
  };

  // Get paginated requisitions
  const getPaginatedRequisitions = (filteredList) => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return filteredList.slice(startIndex, endIndex);
  };

  // Pagination Controls Component
  const PaginationControls = ({ totalItems, itemsPerPage, currentPage, onPageChange }) => {
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    
    if (totalPages <= 1) return null;
    
    return (
      <div className="d-flex justify-content-between align-items-center mt-3">
        <div>
          Showing {(currentPage - 1) * itemsPerPage + 1} to {Math.min(currentPage * itemsPerPage, totalItems)} of {totalItems} requisitions
          {searchTerm && <span className="text-muted ml-2">(filtered from {(activeTab === 'Approved' ? requisitions : disbursedRequisitions).length} total)</span>}
        </div>
        <nav>
          <ul className="pagination">
            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
              <button className="page-link" onClick={() => onPageChange(currentPage - 1)}>
                Previous
              </button>
            </li>
            {[...Array(totalPages)].map((_, i) => (
              <li key={i} className={`page-item ${currentPage === i + 1 ? 'active' : ''}`}>
                <button className="page-link" onClick={() => onPageChange(i + 1)}>
                  {i + 1}
                </button>
              </li>
            ))}
            <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
              <button className="page-link" onClick={() => onPageChange(currentPage + 1)}>
                Next
              </button>
            </li>
          </ul>
        </nav>
      </div>
    );
  };


  return (
    <div id="wrapper">
      <Sidebar userType={theUserType} />

      {/* Content Wrapper */}
      <div id="content-wrapper" className="d-flex flex-column">
        {/* Main Content */}
        <div id="content">
          {/* Topbar */}
          <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">
            {/* Sidebar Toggle*/}
            <button id="sidebarToggleTop" className="btn btn-link d-md-none rounded-circle mr-3">
              <i className="fa fa-bars"></i>
            </button>

            {/* Topbar Search */}
            <form className="d-none d-sm-inline-block form-inline mr-auto ml-md-3 my-2 my-md-0 mw-100 navbar-search">
              <div className="input-group">
                <input type="text" className="form-control bg-light border-0 small" placeholder="Search"
                  aria-label="Search" aria-describedby="basic-addon2" />
                <div className="input-group-append">
                  <button className="btn btn-primary" type="button">
                    <i className="fas fa-search fa-sm"></i>
                  </button>
                </div>
              </div>
            </form>

            {/* Topbar Navbar */}
            <ul className="navbar-nav ml-auto">
              <TopBarIcons />
            </ul>
          </nav>
          {/* End of Topbar */}

          {/* Begin Page Content */}
                    
          <div className="container-fluid">
            {/* Search Bar - Matches StaffRequisitions style */}
            <div className="d-flex justify-content-between align-items-center mb-3" style={{ padding: '0 20px', marginTop: '10px' }}>
              <div>
                <h1 className="h3 mb-0">Approved Requisitions</h1>
              </div>
              <div className="d-flex align-items-center">
                <div className="input-group" style={{ width: '300px' }}>
                  <input 
                    type="text" 
                    className="form-control" 
                    placeholder="Search" 
                    value={searchTerm}
                    onChange={handleSearchChange}
                  />
                  <div className="input-group-append">
                    <button className="btn-outline-secondary round-right-corners" type="button">
                      <i className="fas fa-search"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div id="printable-area" ref={contentRef} style={{ padding: '20px' }}>

              {/* Tabs */}
              <div className="tabs">
                <button
                  className={`nav-link ${activeTab === 'Approved' ? 'active' : ''}`}
                  onClick={() => handleTabClick('Approved')}
                >
                  Approved Requisitions
                </button>
                <button
                  className={`nav-link ${activeTab === 'Disbursed' ? 'active' : ''}`}
                  onClick={() => handleTabClick('Disbursed')}
                >
                  Disbursed Requisitions
                </button>
              </div>

              {/* Error Message */}
              {error && (
                <div className="alert alert-warning mt-3" role="alert">
                  {error}
                </div>
              )}

             
              {/* Approved Requisitions Table */}
              {activeTab === 'Approved' && (
                <div id="requisition-table" className="table-responsive mt-4">
                  {loadingApproved ? (
                    <div className="text-center py-4">
                      <div className="spinner-border text-primary" role="status">
                        <span className="sr-only">Loading...</span>
                      </div>
                      <p className="mt-2">Loading approved requisitions...</p>
                    </div>
                  ) : (
                    <table className="table table-hover table-striped table-bordered text-sm align-middle">
                      <thead className="thead-dark">
                        <tr>
                          <th className="text-nowrap">Staff Name</th>
                          <th className="text-nowrap">Activity Name</th>
                          <th className="text-nowrap">Activity Duration</th>
                          <th className="text-nowrap">Cost Drivers Total</th>
                          <th className="text-nowrap">Approved Date</th>
                          <th className="text-nowrap">Status</th>
                          <th className="text-nowrap">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {(() => {
                          const filtered = filterRequisitions(requisitions);
                          const sorted = [...filtered].sort((a, b) => new Date(b.requisitionDate) - new Date(a.requisitionDate));
                          const paginated = getPaginatedRequisitions(sorted);
                          return paginated.map((requisition) => (
                            <tr key={requisition.requisitionID}>
                              <td>{requisition.staffName}</td>
                              <td>{requisition.activityName}</td>
                              <td>{formatDateRange(requisition.from, requisition.to)}</td>
                              <td>K {calculateTotalAmount(requisition).toLocaleString()}</td>
                              <td>{formatDate(requisition.approvedDate || requisition.requisitionDate)}</td>
                              <td>
                                <div className={`badge ${getStatusClass(requisition.status)}`}>
                                  {requisition.status}
                                </div>
                              </td>
                              <td>
                                <div className="d-flex gap-2 flex-wrap">
                                  <Link to={`/review-requisition/${requisition.requisitionID}`}>
                                    <button
                                      className="btn btn-outline-primary btn-sm"
                                      onClick={() => handleView(requisition.requisitionID)}
                                    >
                                      <i className="fas fa-file-alt me-1"></i> Review
                                    </button>
                                  </Link>
                                </div>
                              </td>
                            </tr>
                          ));
                        })()}
                        {filterRequisitions(requisitions).length === 0 && !error && (
                          <tr>
                            <td colSpan="7" className="text-center text-muted py-4">
                              {searchTerm 
                                ? `"${searchTerm}" not found in the Approved Requisitions tab`
                                : 'not found in the Approved Requisitions tab'}
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                    
                    
                  )}
                  
                  {filterRequisitions(requisitions).length > itemsPerPage && (
                    <PaginationControls
                      totalItems={filterRequisitions(requisitions).length}
                      itemsPerPage={itemsPerPage}
                      currentPage={currentPage}
                      onPageChange={setCurrentPage}
                    />
                  )}

                </div>
              )}

              

              {/* Disbursed Requisitions Table */}
              {activeTab === 'Disbursed' && (
                <div id="requisition-table" className="table-responsive mt-4">
                  {loadingDisbursed ? (
                    <div className="text-center py-4">
                      <div className="spinner-border text-primary" role="status">
                        <span className="sr-only">Loading...</span>
                      </div>
                      <p className="mt-2">Loading disbursed requisitions...</p>
                    </div>
                  ) : (
                    <table className="table table-hover table-striped table-bordered text-sm align-middle">
                      <thead className="thead-dark">
                        <tr>
                          <th className="text-nowrap">Staff Name</th>
                          <th className="text-nowrap">Activity Name</th>
                          <th className="text-nowrap">Activity Duration</th>
                          <th className="text-nowrap">Amount Disbursed</th>
                          <th className="text-nowrap">Disbursed Date</th>
                          <th className="text-nowrap">Status</th>
                          <th className="text-nowrap">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {(() => {
                          const filtered = filterRequisitions(disbursedRequisitions);
                          const sorted = [...filtered].sort((a, b) => new Date(b.requisitionDate) - new Date(a.requisitionDate));
                          const paginated = getPaginatedRequisitions(sorted);
                          return paginated.map((requisition) => (
                            <tr key={requisition.requisitionID}>
                              <td>{requisition.staffName}</td>
                              <td>{requisition.activityName}</td>
                              <td>{formatDateRange(requisition.from, requisition.to)}</td>
                              <td>K {calculateTotalAmount(requisition).toLocaleString()}</td>
                              <td>{formatDate(requisition.disbursedDate)}</td>
                              <td>
                                <div className={`badge ${getStatusClass(requisition.status)}`}>
                                  {requisition.status}
                                </div>
                              </td>
                              <td>
                                <div className="d-flex gap-2 flex-wrap">
                                  <Link to={`/view-requisition/${requisition.requisitionID}`}>
                                    <button
                                      className="btn btn-outline-primary btn-sm"
                                      onClick={() => handleView(requisition.requisitionID)}
                                    >
                                      <i className="fas fa-file-alt me-1"></i> View
                                    </button>
                                  </Link>
                                </div>
                              </td>
                            </tr>
                          ));
                        })()}
                        {filterRequisitions(disbursedRequisitions).length === 0 && !error && (
                          <tr>
                            <td colSpan="7" className="text-center text-muted py-4">
                              {searchTerm 
                                ? `"${searchTerm}" not found in the Disbursed Requisitions tab`
                                : 'not found in the Disbursed Requisitions tab'}
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  )}

                  {filterRequisitions(disbursedRequisitions).length > itemsPerPage && (
                    <PaginationControls
                      totalItems={filterRequisitions(disbursedRequisitions).length}
                      itemsPerPage={itemsPerPage}
                      currentPage={currentPage}
                      onPageChange={setCurrentPage}
                    />
                  )}

                </div>
              )}
            </div>
          </div>
          {/* End of container-fluid */}
        </div>
        {/* End of Main Content */}

        {/* Footer */}
        <footer className="sticky-footer bg-white">
          <div className="container my-auto">
            <div className="copyright text-center my-auto">
              <span>Copyright &copy; Farm Concern International 2025</span>
            </div>
          </div>
        </footer>
        {/* End of Footer */}
      </div>
      {/* End of Content Wrapper */}
    </div>
  );
};

export default ApprovedRequisitionsReviewerView;